import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { StudentMergeResponse } from '../../../_models/search-student/student-merge-response.model';
import { ClientListing } from '../../../_models/clients/client-listing.model';
import { ClientService } from '../../../_services';
import { StudentService } from '../../../_services/student/student.service';
import { ClientListForAddStudentResponse } from '../../../_models/clients/client-list-for-add-student-response.model';
import { ThemeService } from '../../../_helpers/theming-engine/theme.service';
import { FeatureHelperService } from '../../../_helpers/feature-helper/feature-helper.service';
import { ErrorModalHelperService } from '../../../_helpers/error-modal-helper/error-modal-helper.service';
import { SuccessModalHelperService } from '../../../_helpers/success-modal-helper/success-modal-helper.service';

@Component({
    selector: 'upload-add-modal',
    templateUrl: './upload-add-modal.component.html',
    styleUrls: ['./upload-add-modal.component.css'],
    standalone: false
})
export class UploadAddModalComponent implements OnInit {
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;

  public fileAttr: string = 'Upload learner template (file needs to be uploaded as a CSV file format only)';
  private fileAttrHolder: string = 'Upload learner template (file needs to be uploaded as a CSV file format only)';
  public fileBase64Path: string = "";
  public showInvalidFileTypeError: boolean = false;
  public showInvalidFileError: boolean = false;


  public createLogins: boolean = false;

  public warningMessage: boolean = false;
  public errorMessage: boolean = false;
  public uploadResponseMainMessage: string = "";
  public uploadResponseMessages: Array<string> = new Array<string>();

  public clientList: Array<ClientListing> = new Array<ClientListing>();
  public filteredClientList: Array<ClientListing> = new Array<ClientListing>();
  public uploadSelectedClientId: number = 0;
  public showClientAccessError: boolean = false;
  
  public hasInsertPermissions: boolean = false;
  public hasEmailStudentAccessLinkPermission: boolean = false;

  constructor(
    private studentService: StudentService,
    private successModalHelper: SuccessModalHelperService,
    private clientService: ClientService,
    public themeService: ThemeService,
    private featureHelperService: FeatureHelperService,
    private errorModalHelper: ErrorModalHelperService
    ) { }

  ngOnInit() {
    // this.errorMessage = true;
    // this.warningMessage = false;
    // this.uploadResponseMainMessage = "Error Test";
    // this.uploadResponseMessages.push("Test message 1");
    // this.uploadResponseMessages.push("Test message 2");
    // this.uploadResponseMessages.push("Test message 3");
    // this.uploadResponseMessages.push("Test message 4");
    // this.uploadResponseMessages.push("Test message 5");
    // this.uploadResponseMessages.push("Test message 6");

    this.checkPermissions();
    this.populateClientDropdown();
  }

  private checkPermissions(): void {
    let featureList = new Array<string>();
    featureList.push(
      "StudentDataInsert",
      "EmailStudentAccessLink");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (currentUserFeatures.filter(f => f.feature === "StudentDataInsert")[0].enabled) {
      this.hasInsertPermissions = true;
    }
    if (currentUserFeatures.filter(f => f.feature === "EmailStudentAccessLink")[0].enabled) {
      this.hasEmailStudentAccessLinkPermission = true;
    }
    this.themeService.siteContent.enableStudentEmailing;
  }

  public uploadFileEvt(imgFile: any): void {
    if (imgFile.target.files && imgFile.target.files[0]) {
      if (imgFile.target.files[0].size == 0) {
        this.showInvalidFileError = true;
        this.fileInput.nativeElement.value = "";
        this.fileAttr = this.fileAttrHolder;
        this.fileBase64Path = "";
      } else if (this.isAcceptedFileMimeType(imgFile.target.files[0].type)) {
        this.fileAttr = '';
        this.showInvalidFileTypeError = false;
        this.showInvalidFileError = false;
        Array.from(imgFile.target.files).forEach((file: File) => {
          this.fileAttr += file.name + ' - ';
        });

        // HTML5 FileReader API
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.fileBase64Path = e.target.result;
        };
        reader.readAsDataURL(imgFile.target.files[0]);

        // Reset if duplicate image uploaded again
        this.fileInput.nativeElement.value = "";
      } else {
        this.fileInput.nativeElement.value = "";
        this.fileAttr = this.fileAttrHolder;
        this.fileBase64Path = "";
        this.showInvalidFileTypeError = true;
      }
      
    } else {
      this.fileAttr = this.fileAttrHolder;
      this.showInvalidFileTypeError = false;
    }
  }

  public uploadStudent(): void {
    this.studentService.uploadStudent(this.fileBase64Path, this.uploadSelectedClientId, this.createLogins).subscribe((response: StudentMergeResponse) => {

      if (response.successful) {
        this.successModalHelper.show("Successfully uploaded the student.");
        this.fileBase64Path = "";
        this.fileAttr = this.fileAttrHolder;
        this.createLogins = false;
      }
      
      this.errorMessage = !response.successful && response.reponseMessage != "Part of your import has failed";
      this.warningMessage = !response.successful && response.reponseMessage == "Part of your import has failed";
      this.uploadResponseMainMessage = response.reponseMessage;
      this.uploadResponseMessages = response.reponseMessages == null ? new Array<string>() : response.reponseMessages;

      setTimeout(() => {
        const element = document.getElementById("responseMessageContainer")
        if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 10);

    }, error => {
      console.error(error);
      this.errorModalHelper.show("An error has occurred. Please try again or contact your administrator.", error);
    });
  }

  private populateClientDropdown(): void {
    this.clientService.getClientListForAddStudent().subscribe((response: ClientListForAddStudentResponse) => {
      if (response.success) {
        this.clientList = response.clients;
        this.filteredClientList = this.clientList;
      } else if (response.responseMessage.toLowerCase() == "no valid client roles assigned") {
        this.showClientAccessError = true;
      } else {
        this.errorModalHelper.show("An error has occurred. Please try again or contact your administrator.", {isValidationError: false});
      }
    }, error => {
      console.error(error);
      this.errorModalHelper.show("An error has occurred. Please try again or contact your administrator.", error);
    });
  }

  private isAcceptedFileMimeType(fileMimeType: string): boolean {
    
    switch (fileMimeType) {
      case "text/plain":
      case "text/x-csv":
      case "text/csv":
      case "text/comma-separated-values":
      case "text/x-comma-separated-values":
      case "text/tab-separated-values":
      case "application/vnd.ms-excel":
      case "application/csv":
      case "application/x-csv":
        return true;
    
      default:
        return false;
    }
  }

}
